function initializeTakeOverAd() {
  function triggerModal() {
    $('#takeOverAdModel').modal('show');
  }

  function modalDialog() {
    var sessionVal = sessionStorage.getItem('takeOverAdSession');

    if (sessionVal !== 'dismissed')
      triggerModal();
  }

  function setSessionStorage() {
    sessionStorage.setItem('takeOverAdSession', 'dismissed');
  }

  function modalClose() {
    $('#takeOverAdModel').modal('hide');
  }

  function load() {
    modalDialog();
  }

  /* events */
  $('#takeOverAdModel').on('hidden.bs.modal', function () {
    setSessionStorage();
  });

  $('.modal-footer a').on('click', function (e) {
    e.preventDefault();

    var targetBlank = $(this).attr('target'),
      hrefVal = $(this).attr('href');

    setSessionStorage();
    modalClose();

    if (targetBlank === '_blank') {
      window.open(hrefVal, '_blank');
    } else {
      window.location.href = hrefVal;
    }
  })

  load();

}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeTakeOverAd()
})
